var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.433 7.953H8.097v2.184h5.208c-.264 3.048-2.8 4.352-5.2 4.352-3.064 0-5.752-2.416-5.752-5.816 0-3.28 2.56-5.816 5.76-5.816 2.472 0 3.92 1.576 3.92 1.576l1.52-1.584S11.6.673 8.033.673c-4.544 0-8.056 3.84-8.056 8 0 4.04 3.304 8 8.176 8 4.28 0 7.4-2.936 7.4-7.272 0-.92-.12-1.448-.12-1.448"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .673h16v16H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export default ForwardRef;